"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouter = require("react-router");

var _connectedReactRouter = require("connected-react-router");

var _DefaultRouteLoader = _interopRequireDefault(require("./DefaultRouteLoader"));

var _NavList = require("../NavList");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var makeRoutes = function makeRoutes(routes) {
  var makeRouteOrRoutes = function makeRouteOrRoutes(route) {
    return Array.isArray(route.path) ? route.path.map(function (path) {
      return makeRoute(route, path);
    }) : makeRoute(route);
  };

  var makeRoute = function makeRoute(route, path) {
    return _react.default.createElement(_reactRouter.Route, {
      exact: path ? true : false,
      key: path || route.path,
      path: path || route.path,
      component: route.component
    });
  };

  var deleteInvalidOrExternalRoutes = function deleteInvalidOrExternalRoutes(route) {
    return !route.link && route.name && route.path && route.component;
  };

  return routes && Array.isArray(routes) && routes.filter(deleteInvalidOrExternalRoutes).map(makeRouteOrRoutes);
};

var Router = function Router(_ref) {
  var routes = _ref.routes,
      history = _ref.history,
      routeLoader = _ref.routeLoader;
  var RouteLoader = routeLoader || _DefaultRouteLoader.default;
  return _react.default.createElement(_react.Suspense, {
    fallback: _react.default.createElement(RouteLoader, null)
  }, _react.default.createElement(_connectedReactRouter.ConnectedRouter, {
    history: history
  }, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactRouter.Switch, null, makeRoutes(routes)))));
};

Router.propTypes = {
  history: _propTypes.default.object.isRequired,
  routes: _NavList.routesPropType,
  routeLoader: _propTypes.default.node
};
var _default = Router;
exports.default = _default;